export const SAMPLE = "SAMPLE";
export const SAVE_STUDENT_DATA = "SAVE_STUDENT_DATA";
export const SAVE_PG_INFO = "SAVE_PG_INFO";
export const SAVE_UNI_TRANSFER_INFO = "SAVE_UNI_TRANSFER_INFO";
export const SAVE_DIPLOMA_INFO = "SAVE_DIPLOMA_INFO";
export const SAVE_PUTME_INFO = "SAVE_PUTME_INFO";
export const SAVE_SUPPLEMENTARY_INFO = "SAVE_SUPPLEMENTARY_INFO";
export const DIRECT_ENTRY = "DIRECT_ENTRY";
export const SUPPLEMENTARY_PUTME = "SUPPLEMENTARY_PUTME";
export const CCE_APPLICATION = "CCE_APPLICATION";
export const CLEAR_APPLICATION_DATA = "CLEAR_APPLICATION_DATA";
export const SAVE_JUPEB_INFO = "SAVE_JUPEB_INFO";
export const PART_TIME = "PART_TIME";
export const SAVE_MENU_ITEMS = "SAVE_MENU_ITEMS";
export const JUPEP_APPLICATIONS = "JUPEP_APPLICATIONS";
export const CSPG_APPLICATIONS = "CSND_APPLICATIONS";
export const FEES_ASSIGNMENT = "FEES_ASSIGNMENT";
export const SAVE_IMPERSONATION_ITEMS = "SAVE_IMPERSONATION_ITEMS";
export const SAVE_PRE_DEGREE_INFO = "SAVE_PRE_DEGREE_INFO";
export const CLEAR_PERSIST_DATA = "CLEAR_PERSIST_DATA";
export const STAFF_REQUEST = "STAFF_REQUEST";
export const SAVE_FOUR_YEAR_SANDWICH_APPLICATION =
	"SAVE_FOUR_YEAR_SANDWICH_APPLICATION";
export const SAVE_FIVE_YEAR_SANDWICH_APPLICATION =
	"SAVE_FIVE_YEAR_SANDWICH_APPLICATION";
